import PlatformInfo from '../PlatformInfo';
import { PLATFORMS } from '../data';

export default function ProfileTradeLocker() {
  return <PlatformInfo platform={PLATFORMS.tradelocker} />;
}
